import React from 'react';

import { SquaredButton } from '../builder/ActionButton';

const CloseButtonPublic = (props) => {
	const classname = props?.classname || 'close_btn';

	const onclick = (e) => {
		if(props.disabled) return;
		if(props.onClick != undefined) props.onClick(e);
	}

	return (
		<SquaredButton
			icon='knk-close'
			_class={{variable_icon_color:true, other:classname}}
			onClick={() => onclick()}
			aria-label="Close"
		/>
	);
}

export default CloseButtonPublic;